import React from "react";
import "./CommonFooter.css";
import { FaFacebookF, FaInstagram, FaYoutube } from "react-icons/fa6";
import { Link } from "react-router-dom";
import WhatsAppFloat from "./WhatsAppFloat";
import ScrollToTop from "./ScrollToTop"; 
import footerLogo from "../../../assets/images/White Gold.png";

const CommonFooter = ({ productInfo = null }) => {
  return (
    <footer className="footer-v2">
      <div className="footer-v2__main-container">
        
        {/* TOP SECTION: More space above */}
        <div className="footer-v2__header">
          <div className="footer-v2__logo-area">
            <img src={footerLogo} alt="Yug Mantra Logo" className="footer-v2__logo-img" />
            {/* <p className="footer-v2__logo-subtext">Design By Siddharth Fashion</p> */}
          </div>

          <div className="footer-v2__badges">
            <div className="footer-v2__badge shipping-badge">
              <span className="badge-icon">🚚</span>
              <span className="badge-text">Free Shipping <strong>All Over India</strong></span>
            </div>
            <div className="footer-v2__badge razorpay-badge-v2">
              <img
                src="https://badges.razorpay.com/badge-light.png"
                alt="Razorpay Trusted Business"
              />
            </div>
          </div>
        </div>

        <div className="footer-v2__divider"></div>

        {/* MIDDLE SECTION: Equal column gaps */}
        <div className="footer-v2__grid">
          
          <section className="footer-v2__column">
            <h3 className="footer-v2__col-title">CUSTOMER SUPPORT</h3>
            <div className="footer-v2__support-content">
              <p className="footer-v2__quote">“Yug Mantra Design By Siddharth Fashion”</p>
              <p>Showroom No. A-14, Global Textile Market,<br />Nr. Sahara Darawaja , Surat- 395010</p>
              <p>Retail: +91 90334129 75<br />Wholesale: +91 90334129 74</p>
              <p>siddharthfashion1037@gmail.com</p>
              <p className="footer-v2__time">Time: 10:30 AM To 08:30 PM</p>
            </div>
          </section>

          <section className="footer-v2__column">
            <h3 className="footer-v2__col-title">POLICIES</h3>
            <ul className="footer-v2__links">
              <li><Link to="/return-policy">Returns & Exchange</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
              <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
              <li><Link to="/shipping-policy">Shipping Policy</Link></li>
            </ul>
          </section>

          <section className="footer-v2__column">
            <h3 className="footer-v2__col-title">QUICK LINKS</h3>
            <ul className="footer-v2__links">
              <li><Link to="/about-us">About Us</Link></li>
              <li><Link to="/contact-us">Contact Us</Link></li>
            </ul>
            <div className="footer-v2__social">
              <a href="https://www.instagram.com/siddharthfashion1/" target="_blank" rel="noreferrer"><FaInstagram /></a>
              <a href="https://www.facebook.com/siddharthfashionofficial" target="_blank" rel="noreferrer"><FaFacebookF /></a>
              <a href="https://www.youtube.com/@Siddharthfashionofficial" target="_blank" rel="noreferrer"><FaYoutube /></a>
            </div>
          </section>

          <section className="footer-v2__column">
            <h3 className="footer-v2__col-title">AVAILABLE ON</h3>
            <div className="footer-v2__apps">
              {/* Image paths aapki assets folders ke mutabiq adjust karein */}
              <a href="https://play.google.com/store/apps/details?id=com.siddharthfashion" target="_blank" rel="noreferrer">
                <img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" className="app-badge-img" />
              </a>
              <a href="https://apps.apple.com/us/app/siddharth-fashion/id6754088819" target="_blank" rel="noreferrer">
                <img src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg" alt="App Store" className="app-badge-img" />
              </a>
            </div>
          </section>

        </div>

        <div className="footer-v2__divider"></div>

        {/* COPYRIGHT SECTION */}
        <div className="footer-v2__bottom-bar">
          <p>© 2026-2027 Yug Mantra Design By Siddharth Fashion | Made with <span className="heart">❤️</span> by <a href="https://isoftrendsystem.in/" target="_blank" rel="noreferrer">iSoftrend System</a> | All Rights Reserved.</p>
        </div>
      </div>

      <WhatsAppFloat productInfo={productInfo} />
      <ScrollToTop/>
    </footer>
  );
};

export default CommonFooter;
